/**
 * 新規予約ページID
 * @param FLIGHT_SEARCH フライト検索
 * @param CAPTCHA_AUTHENTICATION キャプチャ認証
 * @param ROUNDTRIP_FLIGHT_AVAILABILITY_INTERNATIONAL 往復空席照会結果(国際)
 * @param ROUNDTRIP_FLIGHT_AVAILABILITY_DOMESTIC 往復空席照会結果(国内)
 * @param COMPLEX_FLIGHT_CALENDAR 複雑カレンダー
 * @param COMPLEX_FLIGHT_AVAILABILITY 複雑空席照会結果
 * @param FIND_MORE_FLIGHTS Find more Flights
 * @param INSTANT_SEARCH_API Instant Search API
 * @param PLAN_REVIEW プラン確認
 * @param ESTIMATION お見積り
 * @param PLAN_LIST プランリスト
 * @param AGREEMENT 規約
 * @param SERVICE_REQUEST サービス申込
 * @param LOUNGE_SERVICE_REQUEST ラウンジ申込
 * @param BAGGAGE_REQUEST 手荷物申込
 * @param FLIGHT_MEAL_REQUEST 機内食申込
 * @param PET_RESERVATION_INFORMATION_REQUEST ペットらくのり申込
 * @param PASSENGER_INFORMATION_REQUEST 搭乗者情報入力
 * @param SEATMAP シートマップ
 * @param SEAT_ATTRIBUTE_REQUEST 座席属性指定
 * @param PAYMENT_INPUT 支払情報入力
 * @param AMC_PASSWORD_INPUT AMCパスワード入力
 * @param ANA_BIZ_PAYMENT_INPUT ANA Biz支払情報入力
 * @param BOOKING_COMPLEATED 予約・購入完了
 * @param ANA_BIZ_LOGIN ANA Bizログイン
 * @param ORGANIZATION_SELECT 組織選択
 * @param ANA_BIZ_LOGOUT ANA Bizログアウト
 * @param GOSHOKAI_NET_LOGIN ご紹介ねっと入口
 */
export type ReservationPageIdType = (typeof ReservationPageIdType)[keyof typeof ReservationPageIdType];
export const ReservationPageIdType = {
  FLIGHT_SEARCH: 'P010',
  CAPTCHA_AUTHENTICATION: 'P020',
  ROUNDTRIP_FLIGHT_AVAILABILITY_INTERNATIONAL: 'P030',
  ROUNDTRIP_FLIGHT_AVAILABILITY_DOMESTIC: 'P031',
  COMPLEX_FLIGHT_CALENDAR: 'P032',
  COMPLEX_FLIGHT_AVAILABILITY: 'P033',
  FIND_MORE_FLIGHTS: 'P034',
  INSTANT_SEARCH_API: 'P035',
  PLAN_REVIEW: 'P040',
  ESTIMATION: 'P041',
  PLAN_LIST: 'P042',
  AGREEMENT: 'M043',
  SERVICE_REQUEST: 'P050',
  LOUNGE_SERVICE_REQUEST: 'M051',
  BAGGAGE_REQUEST: 'M052',
  FLIGHT_MEAL_REQUEST: 'M053',
  PET_RESERVATION_INFORMATION_REQUEST: 'P054',
  PASSENGER_INFORMATION_REQUEST: 'M060',
  SEATMAP: 'P070',
  SEAT_ATTRIBUTE_REQUEST: 'P071',
  PAYMENT_INPUT: 'P080',
  AMC_PASSWORD_INPUT: 'M081',
  ANA_BIZ_PAYMENT_INPUT: 'P083',
  BOOKING_COMPLEATED: 'P090',
  ANA_BIZ_LOGIN: 'P010',
  ORGANIZATION_SELECT: 'P011',
  ANA_BIZ_LOGOUT: 'P012',
  GOSHOKAI_NET_LOGIN: 'P020',
} as const;
